import beijing from '@/views/mapComponent/mapData/province/110000.json'
import tianjin from '@/views/mapComponent/mapData/province/120000.json'
import hebei from '@/views/mapComponent/mapData/province/130000.json'
import shanxi from '@/views/mapComponent/mapData/province/140000.json'
import neimeng from '@/views/mapComponent/mapData/province/150000.json'
import liaoning from '@/views/mapComponent/mapData/province/210000.json'
import jilin from '@/views/mapComponent/mapData/province/220000.json'
import heilongjiang from '@/views/mapComponent/mapData/province/230000.json'
import shanghai from '@/views/mapComponent/mapData/province/310000.json'
import jiangsu from '@/views/mapComponent/mapData/province/320000.json'
import zhejiang from '@/views/mapComponent/mapData/province/330000.json'
import anhui from '@/views/mapComponent/mapData/province/340000.json'
import fujian from '@/views/mapComponent/mapData/province/350000.json'
import jiangxi from '@/views/mapComponent/mapData/province/360000.json'
import shandong from '@/views/mapComponent/mapData/province/370000.json'
import henan from '@/views/mapComponent/mapData/province/410000.json'
import hubei from '@/views/mapComponent/mapData/province/420000.json'
import hunan from '@/views/mapComponent/mapData/province/430000.json'
import guangdong from '@/views/mapComponent/mapData/province/440000.json'
import guangxi from '@/views/mapComponent/mapData/province/450000.json'
import hainan from '@/views/mapComponent/mapData/province/460000.json'
import chongqing from '@/views/mapComponent/mapData/province/500000.json'
import sichuan from '@/views/mapComponent/mapData/province/510000.json'
import guizhou from '@/views/mapComponent/mapData/province/520000.json'
import yunnan from '@/views/mapComponent/mapData/province/530000.json'
import xizang from '@/views/mapComponent/mapData/province/540000.json'
import shanxisheng from '@/views/mapComponent/mapData/province/610000.json'
import gansu from '@/views/mapComponent/mapData/province/620000.json'
import qinghai from '@/views/mapComponent/mapData/province/630000.json'
import ningxia from '@/views/mapComponent/mapData/province/640000.json'
import xinjiang from '@/views/mapComponent/mapData/province/650000.json'
import taiwan from '@/views/mapComponent/mapData/province/710000.json'
import xianggang from '@/views/mapComponent/mapData/province/810000.json'
import aomen from '@/views/mapComponent/mapData/province/820000.json'

export const provinceByName = {
  '北京市': beijing,
  '天津市': tianjin,
  '河北省': hebei,
  '山西省': shanxi,
  '内蒙古自治区': neimeng,
  '辽宁省': liaoning,
  '吉林省': jilin,
  '黑龙江省': heilongjiang,
  '上海市': shanghai,
  '江苏省': jiangsu,
  '浙江省': zhejiang,
  '安徽省': anhui,
  '福建省': fujian,
  '江西省': jiangxi,
  '山东省': shandong,
  '河南省': henan,
  '湖北省': hubei,
  '湖南省': hunan,
  '广东省': guangdong,
  '广西壮族自治区': guangxi,
  '海南省': hainan,
  '重庆市': chongqing,
  '四川省': sichuan,
  '贵州省': guizhou,
  '云南省': yunnan,
  '西藏自治区': xizang,
  '陕西省': shanxisheng,
  '甘肃省': gansu,
  '青海省': qinghai,
  '宁夏回族自治区': ningxia,
  '新疆维吾尔自治区': xinjiang,
  '台湾省': taiwan,
  '香港特别行政区': xianggang,
  '澳门特别行政区': aomen
}

const provinces = {
    'beijing': beijing,
    'tianjin': tianjin,
    'hebei': hebei,
    'shanxi': shanxi,
    'neimeng': neimeng,
    'liaoning': liaoning,
    'jilin': jilin,
    'heilongjiang': heilongjiang,
    'shanghai': shanghai,
    'jiangsu': jiangsu,
    'zhejiang': zhejiang,
    'anhui': anhui,
    'fujian': fujian,
    'jiangxi': jiangxi,
    'shandong': shandong,
    'henan': henan,
    'hubei': hubei,
    'hunan': hunan,
    'guangdong': guangdong,
    'guangxi': guangxi,
    'hainan': hainan,
    'chongqing': chongqing,
    'sichuan': sichuan,
    'guizhou': guizhou,
    'yunnan': yunnan,
    'xizang': xizang,
    'shanxisheng': shanxisheng,
    'gansu': gansu,
    'qinghai': qinghai,
    'ningxia': ningxia,
    'xinjiang': xinjiang,
    'taiwan': taiwan,
    'xianggang': xianggang,
    'aomen': aomen
}
export default {
    provinces,
    provinceByName
}